// extracted by mini-css-extract-plugin
module.exports = {"grid":"SectionRecruitment-module--grid--2Piy6","background":"SectionRecruitment-module--background--2psJv","phase":"SectionRecruitment-module--phase--2iHLl"};